export default __webpack_public_path__ + "static/media/background.404d0d9f.jpg";